module.exports = __webpack_public_path__ + "img/p2.81b3c247.png";